/* Copyright (c) 2022 MOCA Systems, Inc. All rights reserved. */

import { Directive, OnInit } from '@angular/core';
import { TpFileUploadComponent } from './tp-file-upload.component';

// In theory there's not much preventing this from being genericized if the need ever comes up
@Directive({
	selector: '[fileUploadSingle]',
})
export class FileUploadSinglerDirective implements OnInit {
	constructor(private fileUpload: TpFileUploadComponent) {}

	private internalOnChange: (value: unknown) => void;
	private internalWriteValue: (value: unknown) => void;

	public ngOnInit(): void {
		this.internalOnChange = this.fileUpload.onChange;
		this.fileUpload.onChange = (value: unknown[]) => this.onChange(value);

		this.internalWriteValue = this.fileUpload.writeValue.bind(this.fileUpload);
		this.fileUpload.writeValue = (value: unknown) => this.writeValue(value);
	}

	private writeValue(value: unknown): void {
		if (value !== undefined && value !== null) {
			this.internalWriteValue([value]);
		} else {
			this.internalWriteValue(value);
		}
	}

	//TODO: make support all output types
	private onChange(files: unknown[] | null) {
		if (files && files.length) {
			this.internalOnChange(files[0]);
		} else {
			this.internalOnChange(files);
		}
	}
}
